import type { PropType } from 'vue';
import type { TabSelectionProvider } from '../TTabBarExtended.types';
import type { TTabProps } from './TTab.types';
import { computed, defineComponent, inject } from 'vue';
import { useStyles } from './TTab.styles';

export const TTab = defineComponent({
  name: 'TTab',
  props: {
    id: {
      type: String as PropType<TTabProps['id']>,
      required: true,
    },
    selected: {
      type: Boolean as PropType<TTabProps['selected']>,
      default: false,
    },
    value: {
      type: [String, Number, Boolean, Object, Array] as PropType<
        TTabProps['value']
      >,
      required: true,
    },
  },
  setup(props, { slots }) {
    const baseClass = useStyles();

    const provider = inject<TabSelectionProvider>('tabSelection');
    if (!provider) {
      throw new Error('tabSelection provider missing.');
    }
    const { selectTab } = provider;

    const handleClick = () => {
      selectTab(props.id);
    };
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key !== 'Enter') {
        return;
      }

      event.preventDefault();
      selectTab(props.id);
    };

    const ariaLabel = computed(() => (props.selected ? 'selected' : ''));

    return () => (
      <div
        class={[
          baseClass.value,
          ariaLabel.value === 'selected' ? `${baseClass.value}--selected` : '',
        ]}
        aria-label={ariaLabel.value}
        onClick={handleClick}
        onKeydown={handleKeydown}
        role="tab"
        tabindex={0}
      >
        {slots.default?.()}
      </div>
    );
  },
});
